import Accordion from '@carvana/ds-accordion';
import { useState } from 'react';
import type {
  ContentModSection,
  ContentModSubSection,
  SeoContent
} from '~/contracts/common/Seo';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import {
  Container,
  Headline,
  HeadlineContainer,
  HeadlineText,
  InfoText,
  InfoSubheading,
  InfoWrapper,
  Wrapper,
  AccordionWrapper
} from './CarGuide.styles';
import { sortSectionPriority } from './utilities';

function checkDoSectionsExist(
  sections: ContentModSection[]
): sections is [ContentModSection, ContentModSection] {
  return sections.length === 2;
}

type OwnProps = {
  contentMods: SeoContent;
};

function Content({ contentMods: mods }: OwnProps) {
  const [isFirstSectionExpanded, setIsFirstSectionExpanded] = useState(false);
  const [isSecondSectionExpanded, setIsSecondSectionExpanded] = useState(false);
  const [isThirdSectionExpanded, setIsThirdSectionExpanded] = useState(false);

  const orderedSections = mods.contentModsSections.sort(sortSectionPriority);
  const doSectionsExist = checkDoSectionsExist(orderedSections);

  const firstSubSections: ContentModSubSection[] = doSectionsExist
    ? orderedSections[0].subSections.sort(sortSectionPriority)
    : [];

  const secondSubSections: ContentModSubSection[] = doSectionsExist
    ? orderedSections[1].subSections.sort(sortSectionPriority)
    : [];

  return doSectionsExist && mods.contentMod ? (
    <Container data-testid="seo-car-guide-section">
      <Wrapper>
        <HeadlineContainer>
          <Headline data-testid="seo-header-text">
            {mods.contentMod.imageHeader1} {mods.contentMod.imageHeader2}
          </Headline>

          <HeadlineText>{mods.contentMod.imageText}</HeadlineText>
        </HeadlineContainer>

        <AccordionWrapper>
          <Accordion
            className="pt-0"
            headerText={`${mods.contentMod.overviewHeader1} ${mods.contentMod.overviewHeader2}`}
            expanded={isFirstSectionExpanded}
            onExpandedChange={setIsFirstSectionExpanded}
            testId="seo-accordion"
          >
            <InfoText>{mods.contentMod.overviewText}</InfoText>
          </Accordion>

          <Accordion
            expanded={isSecondSectionExpanded}
            headerText={mods.contentModsSections[0].sectionHeader}
            onExpandedChange={setIsSecondSectionExpanded}
            testId="seo-accordion"
          >
            {firstSubSections.map(subSection => (
              <InfoWrapper key={subSection.sectionHeader}>
                <InfoSubheading>{subSection.sectionHeader}</InfoSubheading>
                <InfoText>{subSection.sectionText}</InfoText>
              </InfoWrapper>
            ))}
          </Accordion>

          <Accordion
            expanded={isThirdSectionExpanded}
            headerText={mods.contentModsSections[1].sectionHeader}
            onExpandedChange={setIsThirdSectionExpanded}
            testId="seo-accordion"
          >
            {secondSubSections.map(subSection => (
              <InfoWrapper key={subSection.sectionHeader}>
                <InfoSubheading>{subSection.sectionHeader}</InfoSubheading>
                <InfoText>{subSection.sectionText}</InfoText>
              </InfoWrapper>
            ))}
          </Accordion>
        </AccordionWrapper>
      </Wrapper>
    </Container>
  ) : null;
}

export default withErrorBoundary(Content, { section: 'SRP CarGuide' });
